import { provideWidgetClass } from "scrivito"

export const LogoSliderWidget = provideWidgetClass("LogoSliderWidget", {
  attributes: {
    title: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    subtitle: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    logos: ["widgetlist", { only: ["ImageWidget", "LightDarkImageWidget"] }],
    alternativeBackground: "boolean"
  },
  extractTextAttributes: ["title", "subtitle", "logos"]
})

export type LogoSliderWidgetInstance = InstanceType<typeof LogoSliderWidget>
